import { createFeatureSelector } from '@ngrx/store';
import { RecipeHandoffPendingState } from './recipe-handoff-base.action';

// forFeature key, matching the repo-wide '@zerops/zerops/core/<module>' slice
// naming. The slice IS the whole feature state, so a bare createFeatureSelector
// is the correct selector.
export const RECIPE_HANDOFF_BASE_PENDING_FEATURE_NAME = '@zerops/zerops/core/recipe-handoff-base-pending';

export const selectRecipeHandoffPending = createFeatureSelector<RecipeHandoffPendingState>(
  RECIPE_HANDOFF_BASE_PENDING_FEATURE_NAME
);
